<template>
  <div class="conten" @click="showEventi()">
    <div>
      <el-container class="mainBox">
        <el-header class="header flex_jcSB_aiC">
          <div class="flex_aiC headerleft">
            <!-- 一张图, -->
            <img v-if="isShowImg" class="oneImgs" :src="logoImgs2" alt />

            <!-- logo+图片 -->
            <!-- <div class="imgBox">
              <img
                v-if="isShowImg"
                :class="!isShowTitle ? 'logoImg_zt' : 'logoImg'"
                :src="logoImgs"
                alt
              />
            </div>
            <h3 v-if="isShowTitle">{{ MainTitle }}</h3> -->
          </div>

          <div class="headerbox">
            <div class="topTabs">
              <div class="rightTips">
                <el-dropdown @command="handleCommandTabs">
                  <el-button class="righttagICon">
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="a">刷新</el-dropdown-item>
                    <el-dropdown-item command="b">关闭全部</el-dropdown-item>
                    <el-dropdown-item command="c">关闭右侧</el-dropdown-item>
                    <el-dropdown-item command="d">关闭左侧</el-dropdown-item>
                    <el-dropdown-item command="e">关闭其他</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <el-tabs
                v-if="isShowTabs"
                class="leftTap"
                v-model="editableTabsValue"
                @tab-click="goRoute"
                type="card"
                @tab-remove="removeTab"
                closable
              >
                <template v-for="(item, index) in editableTabs">
                  <el-tab-pane
                    :key="index"
                    :label="item.name"
                    :name="item.path"
                  ></el-tab-pane>
                </template>
              </el-tabs>
            </div>
          </div>

          <div class="flex_aiC top_right">
            <!-- 搜索框 -->
            <!-- <div class="searchBox" style="margin-right: 20px">
              <el-input
                placeholder="请输入关键字搜索你想要的内容"
                v-model="selectVal"
                class="input-with-select"
              >
                <el-select
                  v-model="selectKey"
                  slot="prepend"
                  placeholder="请选择"
                  style="width: 100px"
                >
                  <el-option
                    v-for="(itemkey, index) in keyList"
                    :key="index"
                    :label="itemkey.label"
                    :value="itemkey.value"
                  ></el-option>
                </el-select>
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>
            </div>-->

            <div class="newsBox" @click.stop="goMessageAdmin">
              <img class="newsIcon" src="../assets/img/newImgs/news.svg" alt />
              <div class="newNums" v-if="unReadMsgNumber">
                {{ unReadMsgNumber }}
              </div>
            </div>
            <div class="lines"></div>
            <div class="newsBox exportIcon" @click.stop="goExport">
              <el-tooltip
                class="item"
                effect="dark"
                content="导出记录"
                placement="top-start"
              >
                <img class="newsIcon" src="../assets/img/exportIcon.png" alt />
              </el-tooltip>
            </div>
            <div class="lines"></div>

            <el-button
              v-if="userdata"
              type="text"
              style="margin-right: 0px; color: #fff"
              @click.stop="personal"
              >{{ userdata.employeeName || userName }}</el-button
            >
          </div>
        </el-header>
        <el-container>
          <!-- 左边 -->
          <el-aside class="aside" :width="widthstyle">
            <el-radio-group v-model="isCollapse" style="margin-bottom: 0px">
              <el-button @click="openbut">{{ state }}</el-button>
            </el-radio-group>
            <el-menu
              :unique-opened="true"
              :collapse="isCollapse"
              :default-openeds="openeds"
              :default-active="defaultActive"
              router
            >
              <!-- 一级菜单 -->
              <template v-for="(a_item, a_index) in menuList">
                <el-submenu
                  v-if="a_item.children && a_item.children.length > 0"
                  :index="a_index + ''"
                  :key="a_index"
                >
                  <template slot="title">
                    <img
                      v-if="a_item.menuId == '130'"
                      class="imgstyle"
                      :src="kzmbIcon"
                    />
                    <!-- 2==业务订单 -->
                    <img
                      v-else-if="a_item.menuId == '131'"
                      class="imgstyle"
                      :src="yeWuIcon"
                    />
                    <!-- 3==调度派车 -->
                    <img
                      v-else-if="a_item.menuId == '132'"
                      class="imgstyle"
                      :src="fenXi"
                    />
                    <!-- 4==仓库管理 -->
                    <img
                      v-else-if="a_item.menuId == '133'"
                      class="imgstyle"
                      :src="icon3"
                    />
                    <!-- 5==财务管理 -->
                    <img
                      v-else-if="a_item.menuId == '134'"
                      class="imgstyle"
                      :src="caiWuIcon"
                    />
                    <!-- 6==客商管理 -->
                    <img
                      v-else-if="a_item.menuId == '135'"
                      class="imgstyle"
                      :src="huiYuanIcon"
                    />
                    <!-- 7==车辆管理 -->
                    <img
                      v-else-if="a_item.menuId == '136'"
                      class="imgstyle"
                      :src="icon2"
                    />
                    <img
                      v-else-if="a_item.menuId == '137'"
                      class="imgstyle"
                      :src="xiTongIcon"
                    />
                    <img v-else class="imgstyle" :src="kzmbIcon" />
                    <span>{{ a_item.menuName }}</span>
                  </template>
                  <!-- 二级菜单 #333333 -->
                  <div class="childMenu">
                    <div
                      :class="
                        state == '展开' ? 'leftLine noBorder' : 'leftLine'
                      "
                    ></div>
                    <template v-for="(b_item, b_index) in a_item.children">
                      <el-submenu
                        :key="b_index"
                        :index="a_index + '-' + b_index"
                        v-if="b_item.children && b_item.children.length > 0"
                      >
                        <template slot="title">
                          <!-- <i class="el-icon-folder-add"></i> -->
                          <div class="circularBox">
                            <div class="circulars"></div>
                            <span>{{ b_item.menuName }}</span>
                          </div>
                        </template>
                        <div class="childMenu3">
                          <div
                            :class="
                              state == '展开'
                                ? 'leftLine3 noBorder'
                                : 'leftLine3'
                            "
                          ></div>
                          <el-menu-item
                            v-for="c_item in b_item.children"
                            :key="c_item.jumpUrl"
                            :index="c_item.jumpUrl"
                          >
                            <div class="circularBox">
                              <div class="circulars"></div>
                              <span>{{ c_item.menuName }}</span>
                            </div>
                            <!-- {{ c_item.menuName }} -->
                          </el-menu-item>
                        </div>
                      </el-submenu>
                      <el-menu-item
                        v-else
                        :key="b_item.jumpUrl"
                        :index="b_item.jumpUrl"
                      >
                        <!-- <span slot="title">{{ b_item.menuName }}</span> -->
                        <div class="circularBox">
                          <div class="circulars"></div>
                          <span>{{ b_item.menuName }}</span>
                        </div>
                      </el-menu-item>
                    </template>
                  </div>
                </el-submenu>
                <!-- 一级菜单,没有下级 -->
                <el-menu-item v-else :key="a_index" :index="a_item.jumpUrl">
                  <!-- <i class="el-icon-postcard"></i> -->
                  <!-- 1==控制面板 -->
                  <img
                    v-if="a_item.menuId == '130'"
                    class="imgstyle"
                    :src="kzmbIcon"
                  />
                  <!-- 2==业务订单 -->
                  <img
                    v-else-if="a_item.menuId == '131'"
                    class="imgstyle"
                    :src="yeWuIcon"
                  />
                  <!-- 3==调度派车 -->
                  <img
                    v-else-if="a_item.menuId == '132'"
                    class="imgstyle"
                    :src="fenXi"
                  />
                  <!-- 4==仓库管理 -->
                  <img
                    v-else-if="a_item.menuId == '133'"
                    class="imgstyle"
                    :src="icon3"
                  />
                  <!-- 5==财务管理 -->
                  <img
                    v-else-if="a_item.menuId == '134'"
                    class="imgstyle"
                    :src="caiWuIcon"
                  />
                  <!-- 6==客商管理 -->
                  <img
                    v-else-if="a_item.menuId == '135'"
                    class="imgstyle"
                    :src="huiYuanIcon"
                  />
                  <!-- 7==车辆管理 -->
                  <img
                    v-else-if="a_item.menuId == '136'"
                    class="imgstyle"
                    :src="icon2"
                  />
                  <img
                    v-else-if="a_item.menuId == '137'"
                    class="imgstyle"
                    :src="xiTongIcon"
                  />
                  <img v-else class="imgstyle" :src="kzmbIcon" />
                  <span slot="title">{{ a_item.menuName }}</span>
                </el-menu-item>
              </template>
            </el-menu>
          </el-aside>
          <!-- 右边 -->
          <el-main class="main">
            <div v-if="show == true">
              <div class="PersonalCenter" @click.stop="StopBubbling">
                <div class="libox">
                  <div class="liimg">
                    <i class="el-icon-s-flag"></i>
                  </div>
                  <div class="liright">
                    <div class="liboxtop">所属部门:</div>
                    <div class="liboxbot">{{ userdata.departmentName }}</div>
                  </div>
                </div>
                <div class="libox">
                  <div class="liimg">
                    <i class="el-icon-location-outline"></i>
                  </div>
                  <div class="liright">
                    <div class="liboxtop">当前仓库:</div>
                    <div class="liboxbot">{{ userdata.storageName }}</div>
                  </div>
                </div>
                <!-- <div class="libox" @click.stop="informationbut">
                  <div class="liimg">
                    <i class="el-icon-user"></i>
                  </div>
                  <div class="liright">
                    <div class="liboxbot">我的信息</div>
                  </div>
                </div>-->

                <div class="libox" @click.stop="modifyPwdbut">
                  <div class="liimg">
                    <i class="el-icon-edit-outline"></i>
                  </div>
                  <div class="liright">
                    <div class="liboxbot">修改密码</div>
                  </div>
                </div>
                <div class="libox" @click.stop="outLogin">
                  <div class="liimg">
                    <i class="el-icon-remove-outline"></i>
                  </div>
                  <div class="liright">
                    <div class="liboxbot">退出登录</div>
                  </div>
                </div>
              </div>
            </div>

            <el-dialog
              title="修改密码"
              :visible.sync="modifyPwd"
              :before-close="eliminate"
            >
              <div class="pwdform">
                <div class="singleinp">
                  <div @click="QueryNumber = true" class="singleinpleft">
                    原密码:
                  </div>
                  <div class="singleinpright">
                    <el-input
                      type="password"
                      class="input"
                      autocomplete="off"
                      v-model="pwdlist.oldPassword"
                      placeholder="请输入原密码"
                    ></el-input>
                  </div>
                </div>
                <div class="singleinp">
                  <div @click="QueryNumber = true" class="singleinpleft">
                    新密码:
                  </div>
                  <div class="singleinpright">
                    <!-- <el-input type=""></el-input> -->
                    <el-input
                      type="password"
                      class="input"
                      autocomplete="off"
                      v-model="pwdlist.newPasswpord"
                      placeholder="请输入新密码"
                    ></el-input>
                  </div>
                </div>
                <div class="singleinp">
                  <div @click="QueryNumber = true" class="singleinpleft">
                    确认密码:
                  </div>
                  <div class="singleinpright">
                    <el-input
                      type="password"
                      class="input"
                      autocomplete="off"
                      v-model="pwdlist.confirmPassword"
                      placeholder="请再次确定新密码"
                    ></el-input>
                  </div>
                </div>
              </div>
              <div class="footbox">
                <el-button size="small" type="warning" @click="ChangePassword"
                  >确定</el-button
                >
                <el-button size="small" @click="eliminate">取消</el-button>
              </div>
            </el-dialog>

            <el-dialog title="我的信息" :visible.sync="information">
              <div class="Userinfo">
                <div class="Userinfoli">
                  <div class="Userinfolileft">所属部门 :</div>
                  <div class="Userinfoliright">
                    {{ userdata.departmentName }}
                  </div>
                </div>
                <div class="Userinfoli">
                  <div class="Userinfolileft">所属仓库 :</div>
                  <div class="Userinfoliright">{{ userdata.storageName }}</div>
                </div>
                <div class="Userinfoli">
                  <div class="Userinfolileft">用户编号 :</div>
                  <div class="Userinfoliright">{{ userdata.jobNumber }}</div>
                </div>
                <div class="Userinfoli">
                  <div class="Userinfolileft">用户名称 :</div>
                  <div class="Userinfoliright">{{ userdata.employeeName }}</div>
                </div>
              </div>
            </el-dialog>
            <!-- 导航 -->
            <!-- 内容 -->
            <div class="mainConten" ref="mainConten">
              <keep-alive>
                <!-- 需要缓存的视图组件 -->
                <router-view v-if="$route.meta.keepAlive"></router-view>
              </keep-alive>
              <!-- 不需要缓存的视图组件 -->
              <router-view v-if="!$route.meta.keepAlive"></router-view>
            </div>
          </el-main>
        </el-container>
      </el-container>
    </div>
  </div>
</template>

<script>
// import tools from "@/assets/js/tool";
import kzmbIcon from "../assets/img/meunImg/kongZhiMianBan.svg";
import yeWuIcon from "../assets/img/meunImg/yeWu.svg";
import caiWuIcon from "../assets/img/meunImg/caiWu.svg";
import huiYuanIcon from "../assets/img/meunImg/huiYuan.svg";
import xiTongIcon from "../assets/img/meunImg/xiTong.svg";
import fenXi from "../assets/img/meunImg/fenXi.svg";
// import bamiLogo from "../assets/img/rx2.png"; //
import bamiLogo from "../assets/img/index01.svg"; //八米logo
// import bamiLogo from "../assets/img/logoB.png"; //荣祥logo

import icon1 from "@/assets/img/tmsIcon/diaodusiji.png"; //图标-调度司机
import icon2 from "@/assets/img/tmsIcon/card.png"; //图标-车辆管理
import icon3 from "@/assets/img/tmsIcon/cangKu.png"; //图标-仓库管理

import menu_Lx from "@/assets/meunList/meun_Lx";
import menu_wtl from "@/assets/meunList/meun_wtl";

export default {
  inject: ["reload"],
  data() {
    return {
      selectVal: "",
      selectKey: "",
      icon1: "",
      icon2: "",
      icon3: "",
      unReadMsgNumber: 0, //未读消息数量
      userdata: {}, //个人信息
      // //会缓存的路由  白名单
      includeArr: "",
      // //不缓存的路由  黑名单
      excludeArr: "",
      condition: false,
      WarehouseShow: false,
      show: false,
      state: "收起",
      isCollapse: false,
      widthstyle: "200px",
      iconsList: {},
      //侧板菜单栏
      defaultActive: "/controlPanel",
      mianbanpath: "/controlPanel",
      menuList: [
        {
          children: [],
          menuId: 130,
          menuName: "控制面板",
          jumpUrl: "/controlPanel",
        },

        // 天龙的菜单
        ...menu_wtl.menuList,

        // 刘翔的菜单
        // ...menu_Lx.menuList,
      ],
      openeds: ["0"], //菜单默认展开第一个
      uniOpen: true, //侧边只能展开一个，false可以展开多个

      editableTabsNameList: [], //当前导航栏列表路由的名称
      editableTabsValue: "", //当前激活的导航
      timesr: "",
      information: false,
      modifyPwd: false,
      pwdlist: {
        oldPassword: "",
        newPasswpord: "",
        confirmPassword: "",
      },
      clientHeight: "", //高度
      bodyWidth: "", //宽度

      kzmbIcon: "",
      yeWuIcon: "",
      caiWuIcon: "",
      huiYuanIcon: "",
      xiTongIcon: "",
      fenXi: "",
      logoImgs: bamiLogo,
      logoImgs2: "",
      MainTitle: "八米TMS",
      // MainTitle: "八米TMS",
      isShowTitle: false,
      isShowImg: true,

      isShowTabs: true,
      userName: "个人中心",

      keyList: [
        {
          label: "运单号",
          value: "1",
        },
        {
          label: "客户单号",
          value: "2",
        },
      ],
      isTest: false,
      timer: null,
    };
  },
  created() {
    // let DomainName = tools.getDomainName();
    // this.MainTitle = "华远TMS"; //左上角
    // window.document.title='华远TMS'

    this.kzmbIcon = kzmbIcon; //控制面板图片
    this.yeWuIcon = yeWuIcon; //业务管理图片
    this.caiWuIcon = caiWuIcon; //财务图片
    this.huiYuanIcon = huiYuanIcon; //会员
    this.xiTongIcon = xiTongIcon; //系统管理
    this.fenXi = fenXi; //分析
    this.icon1 = icon1; //调度司机
    this.icon2 = icon2; //车辆管理
    this.icon3 = icon3; //仓库管理

    if (window.sessionStorage.editableTabs) {
      this.editableTabs = JSON.parse(window.sessionStorage.editableTabs);
    } else {
      this.editableTabs = [
        {
          name: this.$route.meta.title,
          path: this.$route.path,
        },
      ];
      window.sessionStorage.editableTabs = JSON.stringify(this.editableTabs);
    }
    this.defaultActive = this.$route.fullPath;
    this.editableTabsValue = this.$route.path;
    let arrLength = this.editableTabs.length;
    for (let f = 0; f < arrLength; f++) {
      this.editableTabsNameList.push(this.editableTabs[f].name);
    }

    if (this.$COMMON.isTest) {
      this.isTest = true;
      // 测试服务器
      // this.MainTitle = "荣祥物流"; //左上角
      // this.MainTitle = "八米TMS"; //左上角
      // this.MainTitle = "牵引TMS"; //左上角
    } else {
      // 正式服务器
      let usermenuListList =
        JSON.parse(sessionStorage.getItem("usermenuList")) || [];
      this.menuList = usermenuListList;
      if (usermenuListList.length < 1) {
        this.getLoginUserRoleMenuPerList(); //获取登录用户的菜单权限
      }
    }

    // 左上角logo
    this.$API.getSystemVI().then((res) => {
      let datas = res.data.result || "";
      document.title = datas.tenantSystemName;
      // 租户登陆页logo
      if (datas.tenantLogoUrl) {
        this.logoImgs2 = datas.tenantLogoUrl || "";
      }
    });
    // this.$API.getLogo().then((res) => {
    //   console.log(res);
    //   this.logoImgs2 = res.data.result.logoUrl || "";
    // });

    // this.getStorageList(); //仓库列表
    // this.storageCargoareaList(); //货区列表
    // this.storageCargoareaFrameList(); //货架列表

    // 登录用户信息
    this.$API.wtl_personalInfo().then((res) => {
      this.userdata = res.data.result || "";
      window.localStorage.setItem("userInfo", JSON.stringify(this.userdata));
    });
    // let userdata = this.$TOOLS.getUserInfo() || "";
    // if (!userdata) {
    //   this.$API.wtl_personalInfo().then((res) => {
    //     this.userdata = res.data.result || "";
    //     window.localStorage.setItem("userInfo", JSON.stringify(this.userdata));
    //   });
    // } else {
    //   this.userdata = userdata;
    // }
    // console.log("userdata", userdata);

    // // 获取logo
    // this.$API.getLogo().then((res) => {
    //   this.userdata = res.data.result || [];
    // });
  },
  mounted() {
    if (window.localStorage.getItem("userList")) {
      let userList = JSON.parse(window.localStorage.getItem("userList"));
      console.log("userList", userList);
      this.userName = userList[0].userName;
    }

    // document.title = "八米TMS";
    // document.title = "荣祥物流TMS";
    let tit = window.localStorage.getItem("tenantSystemName");
    document.title = tit;

    this.startTimer();
  },
  beforeDestroy() {
    this.stopTimer(); // 在组件销毁前停止计时器
  },
  watch: {
    $route(to, form) {
      console.log("to", to.meta);
      console.log("form", form.meta);
      if (this.$route.query.isreload == "isreload") {
        //关闭tab
        let num = this.editableTabsNameList.indexOf(form.meta.title);
        this.editableTabsNameList.splice(num, 1);
        this.editableTabs.splice(num, 1);
      } else {
        // let num = this.editableTabsNameList.indexOf(this.$route.meta.title);
        let num = this.editableTabsNameList.indexOf(to.meta.title);
        console.log(num);
        if (num === -1) {
          // this.editableTabsNameList.push(this.$route.meta.title);
          // this.editableTabs.push({
          //   name: this.$route.meta.title,
          //   path: this.$route.path,
          // });
          this.editableTabsNameList.push(to.meta.title);
          this.editableTabs.push({
            name: to.meta.title,
            path: to.path,
          });
        }
        // if (this.defaultActive == "/controlPanel") {
        //   this.defaultActive = this.$route.fullPath;
        // }
        // this.defaultActive = this.$route.fullPath;
        window.sessionStorage.editableTabs = JSON.stringify(this.editableTabs);
      }
      this.editableTabsValue = this.$route.path;
      this.editableTabs = JSON.parse(window.sessionStorage.editableTabs);
    },
  },

  methods: {
    startTimer() {
      this.timer = setInterval(() => {
        this.unReadMessage(); //未读消息数量
      }, 300000);
    },
    stopTimer() {
      clearInterval(this.timer); // 停止计时器
    },

    // 跳转消息管理
    goMessageAdmin() {
      this.$router.push({
        path: "/message/messageList",
      });
    },
    // 跳转导出历史
    goExport() {
      this.$router.push({
        path: "/message/exportList",
      });
    },
    // 消息未读总数
    unReadMessage() {
      this.$API.getUnreadNoticeCount().then((res) => {
        if (res.data.status == "success") {
          this.unReadMsgNumber = res.data.result.count || 0;
        }
      });
    },
    //修改密码
    ChangePassword() {
      let _this = this;
      this.$API.updatePersonalPassword(this.pwdlist).then((res) => {
        if (res.data.status == "success") {
          _this.$message.success("修改成功");
          setTimeout(() => {
            _this.eliminate();
          }, 1000);
        }
      });
    },
    //关闭密码弹窗
    eliminate() {
      this.modifyPwd = false;
      this.pwdlist = {
        oldPassword: "",
        newPasswpord: "",
        confirmPassword: "",
      };
    },
    // 登录用户的全部菜单和权限
    getLoginUserRoleMenuPerList() {
      this.$API.getLoginUserRoleMenuPerList().then((res) => {
        if (res.data.status == "success") {
          let allMenuList = res.data.result.menuVoList || [];
          for (var a = 0; a < allMenuList.length; a++) {
            if (allMenuList[a].number.indexOf("appDriver:") !== -1) {
              // 去掉司机端的菜单
              allMenuList.splice(a, 1);
              a--;
            }
          }
          let allPmList = res.data.result.permissionList || [];

          this.menuList = this.diGuiGetMeun(allMenuList, "-1") || [];

          let permissList = [];
          allPmList.forEach((item) => {
            // if(item)
            permissList.push(item.name);
          });
          if (permissList.length > 0) {
            // console.log("permissList", permissList);
            window.sessionStorage.setItem(
              "btnPermiss",
              JSON.stringify(permissList)
            );
          }

          if (this.menuList.length > 0) {
            window.sessionStorage.setItem(
              "usermenuList",
              JSON.stringify(this.menuList)
            );
          }
        }
      });
    },

    // 展开收起左边菜单
    openbut() {
      this.isCollapse = !this.isCollapse;
      if (this.isCollapse == true) {
        this.state = "展开";
        this.widthstyle = "60px";
      } else {
        this.state = "收起";
        this.widthstyle = "200px";
      }
    },
    //货架列表
    storageCargoareaFrameList() {
      this.$API.storageCargoareaFrameList().then((res) => {
        let huojiaList = res.data.result || [];
        window.localStorage.setItem("huojiaList", JSON.stringify(huojiaList));
      });
    },
    //货区列表
    storageCargoareaList() {
      this.$API.storageCargoareaList().then((res) => {
        let huoquList = res.data.result || [];
        window.localStorage.setItem("huoquList", JSON.stringify(huoquList));
      });
    },
    //获取仓库下拉列表
    getStorageList() {
      this.$API.getStorageList().then((res) => {
        let cangkuList = res.data.result || [];
        window.localStorage.setItem("cangkuList", JSON.stringify(cangkuList));
      });
    },
    // 获取状态展示值
    getStatusValList(status) {
      let param = {
        tableAndFieldName: status,
      };

      this.$API.getStatusValList(param).then((res) => {
        // 包裹状态
        if (status == "package_v1.package_status") {
          let packageStatusList = res.data.result || [];
          window.localStorage.setItem(
            "packageStatusList",
            JSON.stringify(packageStatusList)
          );
        }
        // 拒收单拒收状态
        if (status == "bill_rejection_v1.handle_status") {
          let rejectionStatusList = res.data.result || [];
          window.localStorage.setItem(
            "rejectionStatusList",
            JSON.stringify(rejectionStatusList)
          );
        }
        // 验货单验货状态
        if (status == "bill_inspection_v1.check_status") {
          let inspectionStatusList = res.data.result || [];
          window.localStorage.setItem(
            "inspectionStatusList",
            JSON.stringify(inspectionStatusList)
          );
        }
        // 审核状态
        if (status == "finance_in_record_v1.approve_status") {
          let approveStatusList = res.data.result || [];
          window.localStorage.setItem(
            "approveStatusList",
            JSON.stringify(approveStatusList)
          );
        }
        // 核销状态
        if (status == "finance_in_record_v1.writeoff_status") {
          let writeoffStatusList = res.data.result || [];
          window.localStorage.setItem(
            "writeoffStatusList",
            JSON.stringify(writeoffStatusList)
          );
        }
        // 结算对象类型
        if (status == "finance_in_record_v1.object_status") {
          let objectStatusList = res.data.result || [];
          window.localStorage.setItem(
            "objectStatusList",
            JSON.stringify(objectStatusList)
          );
        }
        // 单据类型
        if (status == "finance_in_record_v1.document_status") {
          let documentStatusList = res.data.result || [];
          window.localStorage.setItem(
            "documentStatusList",
            JSON.stringify(documentStatusList)
          );
        }
        // 打包状态
        if (status == "bill_pack_v1.pack_status") {
          let packStatusList = res.data.result || [];
          window.localStorage.setItem(
            "packStatusList",
            JSON.stringify(packStatusList)
          );
        }
      });
    },
    //导航操作
    handleCommandTabs(m) {
      let currPath = this.$route.fullPath;
      let tabArr = this.editableTabs;
      let currIdx = 0;
      let arrLength = tabArr.length;
      for (var i = 0; i < tabArr.length; i++) {
        if (currPath === tabArr[i].path) {
          currIdx = i;
        }
      }

      if (m == "a") {
        //刷新
        this.reload();
      } else if (m == "b") {
        //关闭全部
        this.editableTabs = [];
        this.editableTabs.push({
          name: "控制面板",
          path: "/controlPanel",
        });
        this.editableTabsNameList.push(this.editableTabs[0].name);
        // this.defaultActive = this.editableTabs[0].path;
        this.editableTabsValue = this.editableTabs[0].path;
        window.sessionStorage.editableTabs = JSON.stringify(this.editableTabs);
        this.$router.push({
          path: "/controlPanel",
        });
        // this.reload();
        this.shuaXin();
      } else if (m == "c") {
        //关闭右侧
        this.editableTabs.splice(currIdx + 1, arrLength - (currIdx + 1));
        // this.defaultActive = this.editableTabs[currIdx].path;
        this.editableTabsValue = this.editableTabs[currIdx].path;
        window.sessionStorage.editableTabs = JSON.stringify(this.editableTabs);
        // this.reload();
        this.shuaXin();
      } else if (m == "d") {
        //关闭左侧
        if (currIdx == 0) {
          return;
        }

        this.editableTabs.splice(1, currIdx - 1);

        /*  this.defaultActive = this.editableTabs[currIdx].path;
                                this.editableTabsValue = this.editableTabs[currIdx].path; */
        window.sessionStorage.editableTabs = JSON.stringify(this.editableTabs);
        // this.reload();
        this.shuaXin();
      } else if (m == "e") {
        //关闭其他
        let arrE = [];
        if (currPath == "/controlPanel") {
          arrE = [];
        } else {
          arrE.push({
            name: "控制面板",
            path: "/controlPanel",
          });
        }

        arrE.push({
          name: this.editableTabs[currIdx].name,
          path: this.editableTabs[currIdx].path,
        });
        this.editableTabs = arrE;
        // this.defaultActive = arrE[0].path;
        // this.editableTabsValue = arrE[0].path;
        window.sessionStorage.editableTabs = JSON.stringify(this.editableTabs);
        // this.reload();
        this.shuaXin();
      }
      this.editableTabsNameList = [];
      for (var q = 0; q < this.editableTabs.length; q++) {
        this.editableTabsNameList.push(this.editableTabs[q].name);
      }
    },
    //获取菜单
    // getAdminMenus() {
    //   this.$API.getAdminMenus().then((res) => {
    //     let menulist = res.data.result || [];
    //     this.diGuiGetMeun(menulist, "-1") || [];
    //   });
    // },
    //递归获取数据
    diGuiGetMeun(data, parentId) {
      let that = this;
      let tree = [];
      let temp;
      data.forEach((item) => {
        if (item.parentId == parentId) {
          let obj = item;
          obj.menuName = item.menuName;
          obj.children = [];

          // 原来
          temp = this.diGuiGetMeun(data, item.menuId);
          if (temp.length > 0) {
            obj.children = temp;
          }
          tree.push(obj);
        }
      });
      //排序
      for (var i = 0; i < tree.length - 1; i++) {
        for (var j = 0; j < tree.length - 1 - i; j++) {
          if (tree[j].sort > tree[j + 1].sort) {
            let temp = tree[j + 1];
            tree[j + 1] = tree[j];
            tree[j] = temp;
          }
        }
      }

      return tree;
    },
    personal() {
      this.show = !this.show;
    },
    // 刷新页面
    shuaXin() {
      // this.reload();
      this.isShowTabs = false;
      this.isShowTabs = true;
    },
    //关闭标签
    removeTab(targetName) {
      let fpath = this.$route.fullPath;
      let fullPath = fpath.split("?")[0];

      if (targetName == "/controlPanel") {
        return;
      }
      let delMyself = false; //是否删除自己
      if (targetName == fullPath) {
        delMyself = true;
      }

      this.editableTabsNameList = [];
      let aLength = this.editableTabs.length;
      if (aLength == 1) {
        this.editableTabs = [];
        this.editableTabs.push({
          name: "控制面板",
          path: "/controlPanel",
        });
        this.editableTabsNameList.push(this.editableTabs[0].name);
        // this.defaultActive = this.editableTabs[0].path;
        this.editableTabsValue = this.editableTabs[0].path;
        this.$router.push({
          path: this.editableTabs[0].path,
        });
        return;
      }
      let b = 0;

      let CopyArr = JSON.parse(JSON.stringify(this.editableTabs));
      for (let a = 0; a < CopyArr.length; a++) {
        if (CopyArr[a].path === targetName) {
          b = a;
        } else {
          this.editableTabsNameList.push(CopyArr[a].name);
        }
      }
      CopyArr.splice(b, 1);

      var cIndex = 0;
      if (delMyself) {
        cIndex = b - 1;
        this.editableTabsValue = CopyArr[cIndex].path;
        this.$router.replace(CopyArr[cIndex].path + "?pageType=isTabs");
      }

      this.editableTabs = CopyArr;
      window.sessionStorage.editableTabs = JSON.stringify(this.editableTabs);

      this.shuaXin();
    },

    //菜单点击跳转
    goRoute(link) {
      console.log("link", link);
      let URL = link.name + "?pageType=isTabs";
      this.$router.replace(URL);
    },
    //仓库信息显示
    Warehousebut() {
      clearTimeout(this.timesr);
      this.WarehouseShow = true;
    },
    //仓库隐藏
    move() {
      this.condition = false;
      this.timesr = setTimeout(() => {
        this.WarehouseShow = false;
      }, 1000);
    },
    //子页面鼠标移入
    MoveInWarehouse() {
      this.WarehouseShow = true;
      clearTimeout(this.timesr);
    },
    //子页面鼠标移开
    Warehousedisappear() {
      this.timesr = setTimeout(() => {
        this.WarehouseShow = false;
      }, 1000);
    },
    showEventi() {
      if (this.show) {
        this.show = false;
        this.WarehouseShow = false;
      }
    },
    //切换仓库
    SwitchWarehouse() {
      this.$confirm("是否切换为该仓库?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$message({
          type: "success",
          message: "切换成功!",
        });
      });
      this.WarehouseShow = false;
      this.show = false;
    },
    //我的信息弹窗
    informationbut() {
      this.WarehouseShow = false;
      this.show = false;
      this.information = true;
    },
    //修改密码
    modifyPwdbut() {
      this.WarehouseShow = false;
      this.show = false;
      this.modifyPwd = true;
    },
    StopBubbling() {},
    //仓库信息影藏
    // 退出登录
    outLogin() {
      let that = this;
      this.$confirm("是否退出本次登录?", "提示")
        .then(() => {
          window.localStorage.removeItem("UserKey");
          window.sessionStorage.clear();
          // this.$message.success("即将退出登录");
          setTimeout(() => {
            that.$router.push({
              path: "/login",
            });
          }, 1000);
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less">
@mainColor: #ef7c1b;
@topAndLeftColor: #414141;
@color_555: #555555;
@lineColor: #888; //左侧菜单展开线

body {
  margin: 0;
  padding: 0;
}
.conten {
  background-color: #f2f2f2;

  .mainBox {
    width: 100%;
    height: 100vh;
    background-color: #fff;
    box-sizing: border-box;

    .header {
      background-color: @topAndLeftColor;
      color: #fff;
      position: relative;
      display: flex;

      padding: 0 20px 0 0;

      .logoImg {
        // width: 28px;
        width: 40px;
        margin-right: 4px;
      }

      .oneImgs {
        width: 160px;
        // height: 50px;
      }

      .logoImg_zt {
        width: 180px;
        height: 46px;
        margin: 0 auto;
      }

      .logoImg2 {
        width: 160px;
      }

      .top_right {
        // width: 100px;
        height: 60px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        z-index: 999;

        .right_heard {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          overflow: hidden;
          border: 1px solid #fff;
          margin-left: 20px;
          box-sizing: border-box;

          img {
            width: 40px;
            height: 40px;
          }
        }

        .newsBox {
          cursor: pointer;
          position: relative;
          .newsIcon {
            width: 18px;
            height: 18px;
            margin-top: 4px;
          }

          .newNums {
            position: absolute;
            top: -10px;
            right: -10px;
            color: #fff;
            font-size: 12px;
            width: 16px;
            height: 16px;
            line-height: 16px;
            padding: 2px;
            text-align: center;
            background-color: #f00;
            border-radius: 50%;
          }
          .exportIcon {
            // background-color: #fff;
            .newsIcon {
              width: 24px;
              height: 22px;
              margin-top: 4px;
            }
          }
        }

        .lines {
          width: 1px;
          height: 16px;
          background-color: #9e9c9c;
          margin: 0 14px;
        }
      }
    }

    // .el-container {
    //   background-color: @topAndLeftColor;
    // }

    .aside {
      background-color: @topAndLeftColor;
      height: calc(100vh - 60px);
      // background-color: #222;

      //

      .el-menu {
        background-color: @topAndLeftColor;
      }

      .el-submenu__title {
        color: #fff;
      }

      .el-menu-item {
        color: #fff;
      }

      .el-menu-item.is-active {
        color: @mainColor;
        // background-color: #f2f2f2;
      }

      .el-submenu .el-menu {
        border: none;
        background-color: #f2f2f2;
      }
    }

    .main {
      height: calc(100vh - 60px);
      width: 100%;
      min-width: 370px;
      box-sizing: border-box;
      // background-color: #d7d7d7;
      background-color: #fff;
      border-radius: 3px 0 0 0;

      .mainConten {
        width: calc(100% - 20px);
        margin: 10px;
        box-sizing: border-box;
        // background-color: #d7d7d7;
        background-color: #fff;
        // height: calc(100vh - 80px);
        //overflow-y: scroll;
        position: relative;
      }
    }
  }
}

.imgstyle {
  width: 16px;
  height: 16px;
  padding: 0 10px 0 0;
}

.el-tabs__header {
  margin-bottom: 0;
}

.el-submenu__title:hover {
  color: #ef7b1a !important;
  background-color: #c1c1c1 !important;
}

.el-menu-item-group__title {
  color: #ef7b1a;
}

.el-main {
  padding: 0;
}

.topTabs {
  bottom: 0;

  .el-tabs__item:nth-of-type(1) .el-icon-close {
    display: none;
  }

  .el-tabs--card > .el-tabs__header .el-tabs__item {
    color: #fff;
  }

  .el-tabs--card > .el-tabs__header .el-tabs__nav {
    background-color: #555555;
    color: #fff;
    border: 0;
  }

  .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    border-bottom: none;
    background-color: #fff;
    color: #000;
    font-weight: bold;
  }

  .el-tabs--card > .el-tabs__header .el-tabs__item {
    border: 0;
  }

  .el-tabs__item {
    height: 30px;
    line-height: 30px;
  }

  box-sizing: border-box;

  background-color: #fff;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .leftTap {
    flex: 1;
    overflow: hidden;
  }

  .rightTips {
    // width: 30px;
    // padding: 0 10px;
    height: 29px;
    line-height: 29px;
    cursor: pointer;
    background-color: @topAndLeftColor;

    width: 29px;
    border-right: 50%;

    .righttagICon {
      padding: 5px;
      border: none;
      background-color: @topAndLeftColor;
    }

    .el-button:focus,
    .el-button:hover {
      // border-color: #fff;
      background-color: #f2f2f2 !important;
    }
  }
}

.conten .mainBox .aside .el-submenu .el-menu {
  background-color: @topAndLeftColor;
}

.el-menu-item:focus {
  background-color: #333333 !important;
}
.el-menu-item:hover {
  background-color: #c1c1c1 !important;
  color: #ef7b1a !important;
}

.aside {
  height: calc(100vh - 61px);
  background-color: @topAndLeftColor;

  .el-button {
    background: @topAndLeftColor;
    border: 0;
  }
}

//表格内容为空时,提示语在左边
// .el-table__empty-block {
//   text-align: left;
// }
//表单收起时颜色
.el-submenu__title {
  color: #fff;
  background-color: @topAndLeftColor;
}

.el-menu-item {
  color: #fff;
  background-color: @topAndLeftColor;
}

.el-submenu__title:hover {
  color: #ef7b1a;
  background-color: #f2f2f2;
}

//仓库详情
.Warehouse {
  position: fixed;
  top: 63px;
  right: 209px;
  z-index: 100;
  border: 1px solid #cccccc;
  box-shadow: 0px 0px 10px #cccccc;
  background-color: #fff;
  width: 150px;
  color: #333;
  font-size: 13px;

  .WarehouseDetails {
    display: flex;
    padding: 5px 15px;
    box-sizing: border-box;
  }

  .WarehouseDetails:hover {
    background-color: #ff8108;
  }
}

//个人中心样式
.PersonalCenter {
  font-size: 13px;
  position: fixed;
  top: 63px;
  right: 5px;
  min-width: 200px;
  max-width: 300px;
  border-radius: 5px;
  border: 1px solid #cccccc;
  box-shadow: 0px 0px 10px #cccccc;
  background-color: #fff;
  z-index: 100;
  display: flex;
  flex-direction: column;

  .libox:hover {
    background-color: #ff8108;
    color: #fff;
    cursor: pointer;
  }

  .libox {
    width: 100%;
    padding: 15px 8px;
    box-sizing: border-box;

    display: flex;
    border-bottom: 1px solid #cccccc;

    .liimg {
      width: 10%;
    }

    .liright {
      width: 90%;
      display: flex;

      .liboxtop {
        color: #999999;
        width: 60px;
      }

      .liboxbot {
        color: #333333;
      }
    }
  }
}

//个人信息样式
.Userinfo {
  width: 100%;
}

.Userinfoli {
  display: flex;
  width: 100%;
  padding: 12px 10%;
}

.Userinfolileft {
  width: 20%;
  display: flex;
  justify-content: flex-end;
}

.Userinfoliright {
  margin-left: 3%;
  color: #000;
}

.Userinfolibtn {
  margin-left: 5%;
  color: #5084e6;
  cursor: pointer;
}

.pwdform {
  width: 80%;
  margin: 0 auto;
  box-sizing: border-box;

  .singleinp {
    width: 80% !important;
    margin: 20px 0 !important;

    .el-input__inner {
      height: 28px;
    }
  }
}

.footbox {
  width: 96%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
}

.el-tabs__nav-next,
.el-tabs__nav-prev {
  line-height: 25px;
  color: #fff;
}

.aside .el-button {
  color: #ef7c1b;
}

.headerleft {
  width: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.headerbox {
  flex: 1;
  height: 60px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  overflow: hidden;
  box-sizing: border-box;
}

.el-tabs__item {
  height: 22.5px;
  line-height: 22.5px;
}

//左边不对齐
.el-menu--collapse {
  width: 100%;
}

//左边不对齐
.el-menu {
  border: 0;
}

//绑定class
.HeadInputbox1 {
  height: "";
}

//绑定class
.active {
  height: 40px;
  margin-bottom: 10px;
}

.container {
  .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    background-color: #fff !important;
    color: @mainColor;
  }
}

.el-tabs__content {
  background-color: #fff;
}

.topTabs {
  font-size: 13px;
  // height: 22px !important;
  background-color: @topAndLeftColor;

  .el-tabs--card > .el-tabs__header {
    border: 0;
  }
}

//左上角按钮
.topTabs .rightTips .righttagICon {
  background-color: #555555 !important;
  color: #fff;
  border-radius: 50%;
}

.el-icon--right {
  margin-left: 0;
}

//左上角按钮
.topTabs .rightTips .el-button:focus,
.topTabs .rightTips .el-button:hover {
  background-color: @color_555 !important;
  color: #555;
}

.searchBox {
  border-radius: 30px;
  overflow: hidden;
  min-width: 290px;

  .el-input__icon {
    line-height: 30px;
  }

  .el-input-group__append,
  .el-input-group__prepend {
    border: none;
    color: #fff;
    background-color: @color_555;
  }
  .el-input-group--append .el-input__inner,
  .el-input-group__prepend {
    border: none;
  }

  .el-input-group__append button.el-button {
    color: @mainColor;
    font-size: 18px;
  }

  .el-input-group--append .el-input__inner,
  .el-input-group__prepend {
    background-color: @color_555 !important;
  }

  .el-input-group--append .el-input__inner {
    color: #fff !important;
  }
}

// 第二级菜单(展开线和圆点)
.childMenu {
  background-color: #f00;
  position: relative;

  .leftLine {
    position: absolute;
    width: 1px;
    height: 100%;
    background-color: @lineColor;
    left: 26px;
    z-index: 99;
  }
  .noBorder {
    width: 0;
  }

  .el-submenu__title,
  .el-menu-item {
    color: #fff;
    background-color: #333;
  }

  .circularBox {
    position: relative;
    .circulars {
      position: absolute;
      width: 5px;
      height: 5px;
      background-color: #000;
      border: 1px solid #fff;
      border-radius: 50%;
      z-index: 100;
      left: -17px;
      top: 25px;
    }
  }
}
// 第三级菜单 展开线和圆点
.childMenu3 {
  position: relative;

  .leftLine3 {
    position: absolute;
    width: 1px;
    height: 100%;
    background-color: @lineColor;
    left: 46px;
    z-index: 99;
  }
  .noBorder {
    width: 0;
  }

  .circularBox {
    position: relative;
    .circulars {
      position: absolute;
      width: 5px;
      height: 5px;
      background-color: #000;
      border: 1px solid #fff;
      border-radius: 50%;
      z-index: 100;
      left: -17px;
      top: 25px;
    }
  }
}

.imgBox {
  // background-color: #fff;
  // border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 4px;
}
</style>
